$( function() {
	$('form[name=profile_update]').on('submit', function(e) {
		e.preventDefault();
		var $form = $(this);
		var _data = $form.serializeArray();
		var _url = $form.attr('action');

		var formdata = {};
		for(i = 0; i < _data.length; i++) {
			formdata[ _data[i].name ] = _data[i].value;
		}

		$.post(_url, _data, function(res) {
			$log = $form.find('ul.log');
			if(res.error) {
				$log
				.fadeOut()
				.queue( function() {
					$log.empty();
					$.each(res.errors, function(i, msg) {
						$log.append( $('<li class="error">' + msg + '</li>') );
					});
					$log.dequeue();
				})
				.fadeIn();
			}
			else {
				$log.fadeOut()
				.queue( function() {
					$log.empty();
					$log.append($('<li class="info">'+res.feedback+'</li>'));
					$log.dequeue();
				})
				.fadeIn();
			}
		});
	});
});